export default __webpack_public_path__ + "static/media/Arouramain.bb81a54a.png";